// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"165":"343376ec","453":"9e4ae166","796":"fccd9d45"}[chunkId] + ".chunk.js";
};